var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2121_22012)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.76953 7.875C10.3035 8.08444 10.7883 8.40222 11.1933 8.80833C11.9747 9.58973 12.4136 10.6495 12.4136 11.7546C12.4136 12.8596 11.9747 13.9194 11.1933 14.7008L8.36286 17.5313C7.58146 18.3126 6.52166 18.7516 5.41661 18.7516C4.31156 18.7516 3.25176 18.3126 2.47036 17.5313C1.68898 16.7499 1.25 15.6901 1.25 14.585C1.25 13.4799 1.68898 12.4201 2.47036 11.6388L5.30078 8.80833",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2303 12.125C9.69634 11.9156 9.21157 11.5978 8.80654 11.1917C8.02516 10.4103 7.58618 9.35046 7.58618 8.24541C7.58618 7.14035 8.02516 6.08056 8.80654 5.29916L11.637 2.46874C12.4184 1.68736 13.4782 1.24838 14.5832 1.24838C15.6883 1.24838 16.7481 1.68736 17.5295 2.46874C18.3108 3.25014 18.7498 4.30994 18.7498 5.41499C18.7498 6.52005 18.3108 7.57984 17.5295 8.36124L14.699 11.1917",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2121_22012"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.34a6b79ac86a6fe1c78fda0e1a75fd70.svg";
export { ForwardRef as ReactComponent };